module.exports = __webpack_public_path__ + "img/notes.5640154f.png";